// removed by extract-text-webpack-plugin
module.exports = {"TwoFactor":"TwoFactor--1UhGr","InfoLink":"InfoLink--1N2a1","PhoneNumber":"PhoneNumber--3kkvm"};